import React, { useEffect, useState } from 'react';

import { useAppDispatch } from 'app/config/store';

import {
  Modal
} from 'antd';
import {
  getAssociates,
  getOnlyPersonInOrg as getEmployees,
  getKrTypes,
  getQualityEvaluationTypes
} from 'app/entities/common/common.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import CopyKRQualitativeVer from './copy-kr-qualitative-ver';
import CopyKRQuantitativeVer from './copy-kr-quantitative-ver';
import CopyKRQualitative from './copy-kr-qualitative';
import CopyKRQuantitative from './copy-kr-quantitative';
type KrFormType = {
  isOpen: boolean;
  isEdit: boolean;
  onClose: (isReload?: boolean) => void;
  idObjective?: string;
  planPeriodIdSelected?: string;
  idKrBaseSelected?: string;
  krTypeRequest?: KrTypes;
  planPeriodType?: PlantPeriodType;
  isReadOnly?: boolean;
  selectedPeriod?: number;
};

export const CopyKRVer = ({ isOpen, isEdit, onClose, planPeriodIdSelected, idObjective, idKrBaseSelected, krTypeRequest, planPeriodType, isReadOnly, selectedPeriod }: KrFormType) => {
  const dispatch = useAppDispatch();

  const [krType, setKrType] = useState(krTypeRequest ?? KrTypes.Qualitative)

  useEffect(() => {
    innitData();
  }, [isOpen]);

  const innitData = () => {
    // get detail
    dispatch(getAssociates());
    dispatch(getEmployees());
    dispatch(getQualityEvaluationTypes());
    dispatch(getKrTypes());
    dispatch(getPlanPeriods({}));
  };

  const handleClose = (isReload = false) => {
    onClose(isReload);
  };

  return (
    <Modal
      open={isOpen}
      maskClosable={false}
      closeIcon={null}
      onCancel={null}
      footer={null}
      width={1500}
    >
      {krType === KrTypes.Qualitative ? (
        <CopyKRQualitativeVer
          handleClose={handleClose}
          handleNextData={() => { }}
          hideNextKr={false}
          onClose={handleClose}
          idKrBaseSelected={idKrBaseSelected}
          idObjective={idObjective}
          krTypeRequest={krTypeRequest}
          planPeriodIdSelected={planPeriodIdSelected}
          planPeriodType={planPeriodType}
          handleChangeKRType={setKrType}
          isEdit={isEdit}
          isReadOnly={isReadOnly}
          selectedPeriod={selectedPeriod}
          krType={krType}
        />
      ) : (
        <CopyKRQuantitativeVer
          handleClose={handleClose}
          handleNextData={() => { }}
          hideNextKr={false}
          onClose={handleClose}
          idKrBaseSelected={idKrBaseSelected}
          idObjective={idObjective}
          krTypeRequest={krTypeRequest}
          planPeriodIdSelected={planPeriodIdSelected}
          planPeriodType={planPeriodType}
          isEdit={isEdit}
          isReadOnly={isReadOnly}
          handleChangeKRType={() => setKrType(krType)}
          selectedPeriod={selectedPeriod}
          KrType={krType}
        />
      )}
    </Modal>
  );
};

export default CopyKRVer;
